import { WorkbookNavItem } from '../⚛️atoms/WorkbookNavItem';
import { useRef, useState } from 'react';
import { getTemplateLessonId } from '../../utils/workbookV2';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useLockedTranslate from '../../Hooks/useLockedTranslate';
import { getTranslation } from '../../utils/translationHelper';

export const WorkbookNavV2ChapterGroup = ({ currentLesson, currentChapter, pendingLessonId, isNavigating, onClick, workbook }) => {
  const completedLessons = currentChapter.lessons.filter((lesson) => lesson.completed).length;
  const totalLessons = currentChapter.lessons.length;
  const chapterComplete = totalLessons > 0 && completedLessons === totalLessons;
  const activeInChapter = currentChapter.lessons.some(
    (lesson) => getTemplateLessonId(lesson) === getTemplateLessonId(currentLesson)
  );
  const [showDropdown, setShowDropdown] = useState(!chapterComplete);
  const chapterRef = useRef(null);
  const { lang } = useLockedTranslate(workbook);
  const getLocalizedText = (item, key) => {
    if (!item) {
      return '';
    }

    return lang === 'en' ? item[key] ?? '' : getTranslation(item.translations, lang, key, item[key] ?? '');
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };
  return (
    <>
      <div className="relative w-full bg-white">
        <div className="flex w-full items-center border-b border-slate-100">
          <WorkbookNavItem
            ref={chapterRef}
            title={getLocalizedText(currentChapter, 'description')}
            subtitle={getLocalizedText(currentChapter, 'title')}
            key={currentChapter?._id}
            onClick={toggleDropdown}
            showCompleted={false}
            variant="chapter"
            statusElement={
              chapterComplete ? (
                <CheckCircleIcon className="size-7 shrink-0 text-pdteal" />
              ) : (
                <span className="shrink-0 text-[12px] font-semibold text-slate-400">{completedLessons}/{totalLessons}</span>
              )
            }
            trailingElement={
              <ChevronRightIcon
                className="size-4 shrink-0 text-slate-400 transition-transform duration-200"
                style={{ transform: showDropdown ? 'rotate(90deg)' : 'rotate(0deg)' }}
              />
            }
            current={activeInChapter}
          />
        </div>
        {showDropdown && (
          <div className="joyride-nav-open sticky top-0 ml-6 flex h-full flex-col border-l border-slate-100 pl-3">
            {currentChapter.lessons.map((lesson, index) => {
              const lessonId = getTemplateLessonId(lesson);
              const lessonIsCurrent = lessonId === getTemplateLessonId(currentLesson);
              const lessonIsPending = isNavigating && lessonId === pendingLessonId;

              return (
                <div className="relative flex flex-col" key={index}>
                  <WorkbookNavItem
                    title=""
                    subtitle={getLocalizedText(lesson, 'title')}
                    onClick={() => onClick(lessonId)}
                    current={lessonIsCurrent}
                    shouldScrollTo={lessonIsCurrent}
                    completed={lesson.completed}
                    variant="lesson"
                    isLoading={lessonIsPending}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
